import { useContext } from 'react';
import { ConfigurationDetailContext, ConfigurationDetailContextType } from '../configuration-detail.context';

export const useConfigurationDetailContext = (): ConfigurationDetailContextType => {
    const context = useContext(ConfigurationDetailContext);
    if (context === undefined) {
        throw new Error('useConfigurationDetailContext must be used within ConfigurationDetailProvider');
    }
    return context;
};
